module.exports = __webpack_public_path__ + "img/13n.1d69ddc1.png";